import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["styles", "caret", "split", "nav", "tag", "href"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, forwardRef, useContext } from 'react';
import classNames from 'classnames';
import { Reference } from 'react-popper';
import { applyStylingHoc } from '../../lib/styling.js';
import Button from '../Button/index.js';
import baseStyles from './Dropdown.scss';
import { DropdownContext } from './Dropdown.js';
var ButtonWithRef = forwardRef(function (props, ref) {
  return React.createElement(Button, _objectSpread(_objectSpread({}, props), {}, {
    innerRef: ref
  }));
});
ButtonWithRef.displayName = 'ButtonWithRef';
var defaultProps = {
  'aria-haspopup': true,
  color: 'secondary',
  styles: {}
};
export var DropdownToggle = function DropdownToggle(props) {
  var context = useContext(DropdownContext);

  var onClick = function onClick(e) {
    if (props.disabled) {
      e.preventDefault();
      return;
    }

    if (props.nav && !props.tag) {
      e.preventDefault();
    }

    if (props.onClick) {
      props.onClick(e);
    }

    context.toggle(e);
  };

  var renderTag = function renderTag() {
    var refProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var styles = props.styles,
        caret = props.caret,
        split = props.split,
        nav = props.nav,
        tag = props.tag,
        href = props.href,
        rest = _objectWithoutProperties(props, _excluded);

    var ariaLabel = rest['aria-label'];
    var classes = classNames(styles.toggle, (caret || split) && styles['has-caret'], split && styles['toggle-split'], nav && styles['nav-link']);
    var children = rest.children || ariaLabel && React.createElement("span", {
      className: "sr-only"
    }, ariaLabel);
    var Tag;
    var hrefProp = href;

    if (nav && !tag) {
      Tag = 'a';
      hrefProp = '#';
    } else if (!tag) {
      Tag = ButtonWithRef;
    } else {
      Tag = tag;
    }

    return React.createElement(Tag, _objectSpread(_objectSpread(_objectSpread({}, rest), refProps), {}, {
      href: hrefProp,
      className: classes,
      onClick: onClick,
      "aria-expanded": context.isOpen
    }), children);
  };

  if (context.inNavbar) {
    return renderTag();
  }

  return React.createElement(Reference, null, function (refProps) {
    return renderTag(refProps);
  });
};
DropdownToggle.defaultProps = defaultProps;
export default applyStylingHoc(baseStyles)(memo(DropdownToggle));